import {
  CASE_FETCH_BY_ID,
  CASE_FETCHED_BY_ID_SUCCESS,
  CASE_FETCHED_BY_ID_FAILED,
} from './available'
import vue from "vue";
import {RequestState} from "../../requestState";

export default {
  [CASE_FETCH_BY_ID](state, {caseId}) {
    vue.set(state.caseInfos, caseId, {})
    vue.set(state.caseInfos[caseId], 'requestState', RequestState.Loading)
  },
  [CASE_FETCHED_BY_ID_SUCCESS](state, {caseId, response}) {
    vue.set(state.caseInfos, caseId, {})
    vue.set(state.caseInfos[caseId], 'requestState', RequestState.Success)
    vue.set(state.caseInfos[caseId], 'response', response)
  },
  [CASE_FETCHED_BY_ID_FAILED](state, {caseId}) {
    vue.set(state.caseInfos, caseId, {})
    vue.set(state.caseInfos[caseId], 'requestState', RequestState.Failed)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/case.js